import React from 'react';
import { Link } from 'react-router-dom';
import { ADMIN_MENU_GROUPS } from '../../constants/adminMenu';

const AdminOverview = () => {
  const totalPages = ADMIN_MENU_GROUPS.reduce((sum, g) => sum + g.items.length, 0);

  return (
    <div>
      <h2 className="text-2xl font-bold text-gold mb-1">Genel Bakış</h2>
      <p className="text-white/60 text-sm mb-8">
        Tüm yönetim sayfalarına buradan ulaşabilirsiniz. {totalPages} sayfa, {ADMIN_MENU_GROUPS.length} kategoriye ayrılmış durumda —
        aradığınızı bulamıyorsanız soldaki menüden ilgili kategoriyi açın.
      </p>

      <div className="space-y-8">
        {ADMIN_MENU_GROUPS.map((group) => {
          const GroupIcon = group.icon;
          return (
            <div key={group.key}>
              <div className="flex items-center gap-2 mb-3">
                <GroupIcon className="text-gold/70 text-sm" />
                <h3 className="text-sm font-bold uppercase tracking-wider text-gold/70">{group.label}</h3>
              </div>
              <div className="grid grid-cols-2 sm:grid-cols-3 xl:grid-cols-4 gap-3">
                {group.items.map((item) => {
                  const ItemIcon = item.icon;
                  return (
                    <Link
                      key={item.path}
                      to={item.path}
                      className="group flex items-center gap-3 bg-navy-800/50 hover:bg-navy-700/60 border border-gold/15 hover:border-gold/50 rounded-xl p-4 transition-all duration-200 hover:-translate-y-0.5"
                    >
                      <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-gold/10 text-gold group-hover:bg-gold/20 transition-colors">
                        <ItemIcon />
                      </div>
                      <span className="text-sm font-medium text-white/85 group-hover:text-gold transition-colors leading-tight">
                        {item.label}
                      </span>
                    </Link>
                  );
                })}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default AdminOverview;
